export default __webpack_public_path__ + "locales/bg/ConvertPasswordDialog.json?hash=fa936756631e095de892773c9fab47c7";